export function calculateStandingsWithRanks(players) {
    if (!players.length)
        return [];
    const sortedPlayers = sortPlayersByScore(players);
    return calculateRanks(sortedPlayers);
}
function sortPlayersByScore(players) {
    return [...players].sort((a, b) => b.score - a.score ||
        (b.tiebreaker ?? 0) - (a.tiebreaker ?? 0) ||
        (b.seed ?? 0) - (a.seed ?? 0));
}
function calculateRanks(sortedPlayers) {
    let currentRank = 0;
    let currentRankGroup = 0;
    let lastPlayer = null;
    return sortedPlayers.map((player, index) => {
        const calculationResult = calculatePlayerRank({
            player,
            index,
            lastPlayer,
            currentRank,
            currentRankGroup,
            allPlayers: sortedPlayers,
        });
        lastPlayer = calculationResult.result;
        currentRank = calculationResult.rank;
        currentRankGroup = calculationResult.rankGroup;
        return calculationResult.result;
    });
}
function calculatePlayerRank({ player, index, lastPlayer, currentRank, currentRankGroup, allPlayers, }) {
    const result = { ...player };
    let newRank = currentRank;
    let newRankGroup = currentRankGroup;
    if (!result.matches) {
        // Non-participating players should keep the last rank and get "-" range
        result.rankRange = "-";
        if (lastPlayer?.matches) {
            newRankGroup++;
        }
        // Keep the last rank for non-participating players
        newRank = lastPlayer?.rank ?? index + 1;
    }
    else if (!lastPlayer || result.score !== lastPlayer.score) {
        // New rank group for participating players with different scores
        newRank = index + 1;
        const rankGroupCount = countPlayersWithSameScore(result.score, allPlayers);
        result.rankRange = formatRankRange(newRank, rankGroupCount);
        newRankGroup++;
    }
    else {
        // Same score as last player, use same rank and range
        result.rankRange = lastPlayer.rankRange;
    }
    result.rank = newRank;
    result.rankGroup = newRankGroup;
    return {
        result,
        rank: newRank,
        rankGroup: newRankGroup,
    };
}
function countPlayersWithSameScore(score, players) {
    return players.filter((p) => p.score === score && p.matches).length;
}
function formatRankRange(rank, groupCount) {
    return groupCount === 1 ? rank : `${rank} - ${rank + groupCount - 1}`;
}
export const getJSONTournamentAtRound = (tournament, players, games, rounds, roundNumber) => {
    return JSON.stringify({
        ts: Date.now(),
        tournament: {
            ...tournament,
            id: tournament.id,
            currentRound: roundNumber,
        },
        players: players.map((p) => {
            return {
                ...p,
                games: [],
            };
        }),
        games: games.filter((g) => g.roundNumber <= roundNumber),
        rounds: rounds.filter((r) => r.roundNumber <= roundNumber),
    }, undefined, 4);
};
export const getPlayerReward = (rank, reward, rewardParticipation) => {
    if (!reward || !rank)
        return null;
    if (rank === 1)
        return `${reward}|1`;
    else if (rank === 2)
        return `${reward}|2`;
    else if (rank === 3)
        return `${reward}|3`;
    else if (rewardParticipation)
        return "Participation";
    return null;
};
export const getRewardPoints = (reward) => {
    switch (reward) {
        case "Trophy|1":
            return 1000000;
        case "Trophy|2":
            return 100000;
        case "Trophy|3":
            return 10000;
        case "Medal|1":
            return 1000;
        case "Medal|2":
            return 100;
        case "Medal|3":
            return 10;
        case "Participation":
            return 1;
        default:
            return 0;
    }
};
